import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface ICheckboxIconProps {
    className?: string;
}

const CheckboxIcon = (props: ICheckboxIconProps) => {
    const className = classNames('elc-checkbox-icon', props.className);
    const image = `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' version='1.1'%3E%3Cpath d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' /%3E%3C/svg%3E")`;

    return <Icon className={className} size={'large'} image={image} />;
};

export { CheckboxIcon };
